module.exports = __webpack_public_path__ + "static/media/GDocsDraftPrivacyNotice_EN.764f5684.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GDocsDraftPrivacyNotice_EN.pdf
// module id = 285
// module chunks = 4